'use client';

import flip from './flip.js';
import getPosition from './getPosition.js';
import hide from './hide.js';
import shift from './shift.js';

function computePosition(reference, popup, configs) {
    var position = configs.position, placement = configs.placement, scrollableParents = configs.scrollableParents, popupConfigs = configs.popupConfigs;
    /*
     * Make popup flip
     * */
    var flippedPlacement = flip({
        position: position,
        reference: reference,
        popup: popup,
        scrollableParents: scrollableParents,
        placement: placement,
        popupConfigs: popupConfigs
    });
    var shiftValues = shift({
        position: position,
        reference: reference,
        popup: popup,
        scrollableParents: scrollableParents,
        placement: placement,
        popupConfigs: popupConfigs
    });
    var isReferenceHidden = hide({
        reference: reference,
        scrollableParents: scrollableParents,
        popupConfigs: popupConfigs
    });
    var args = {
        placement: flippedPlacement,
        position: position,
        reference: reference,
        popup: popup,
        popupConfigs: popupConfigs,
        shiftValues: shiftValues
    };
    var _a = getPosition(args), x = _a.x, y = _a.y;
    return {
        x: x,
        y: y,
        position: position,
        placement: flippedPlacement,
        isReferenceHidden: isReferenceHidden
    };
}

export { computePosition as default };
//# sourceMappingURL=computePosition.js.map
